/* global Office */

import { asOfficeError, officeErrorLocation } from "@/lib/office/office-error";

/**
 * Format an Office.js or generic error into a user-friendly message.
 */
export function formatOfficeError(err: unknown): string {
  const office = asOfficeError(err);
  if (office) {
    return `Outlook error (${office.code})${officeErrorLocation(office)}: ${office.message}`;
  }
  if (err instanceof Error) {
    return err.message;
  }
  if (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as { message: unknown }).message === "string"
  ) {
    return (err as { message: string }).message;
  }
  return "Unknown error";
}
